<template>
  <div class="user-admin-view">
    <user-search-input
      ref="searchInput"
      :initial-selected-role="initialSelectedRole"
      :initial-search-state="initialSearchState"
      :all-roles="allRoles"
    ></user-search-input>
    <user-grid
      ref="grid"
      :users="users"
      :editUserUrl="generateEditUserLink()"
      v-if="users.length > 0"
    ></user-grid>
    <div v-else>
      <p>No matching users found</p>
    </div>
  </div>
</template>

<script>
// noinspection ES6CheckImport
import UserGrid, {
  RemoveRoleEvent,
  AddRoleEvent,
  ManageUserEvent,
  MessageUserEvent,
  ViewProfileEvent
} from "./UserGrid.vue";
// noinspection ES6CheckImport
import UserSearchInput, {
  NewSearchRoleEvent,
  NewSearchInputEvent,
  UserSearchEvent
} from "./UserSearchInput.vue";
import { RightTrim } from "../lib/Sanitation";
import MentorApplicationApi from "../lib/MentorApplicationApi.js";

const SearchParam = "search";

export default {
  name: "UserSearchView",
  components: { UserSearchInput, UserGrid },
  props: {
    users: { type: Array, default: () => [] },
    apiRootUrl: { type: String, required: true },
    rootUserAdminUrl: { type: String, required: true },
    userProfileUrl: { type: String, required: true },
    messageRootUrl: { type: String, required: true },
    userAdminUrl: { type: String, required: true },
    allRoles: { type: Array, required: true },
    initialSelectedRole: { type: String, default: "All" },
    initialSearchState: { type: String, default: "" }
  },
  mounted() {
    if (this.$refs.grid) {
      // conditional required because if no search results, the component isn't mounted and present
      this.$refs.grid.$on(RemoveRoleEvent, this.remove);
      this.$refs.grid.$on(AddRoleEvent, this.add);
      this.$refs.grid.$on(ManageUserEvent, this.manage);
      this.$refs.grid.$on(MessageUserEvent, this.goToMessage);
      this.$refs.grid.$on(ViewProfileEvent, this.viewProfile);
    }
    this.$refs.searchInput.$on(NewSearchRoleEvent, this.changeSearchRole);
    this.$refs.searchInput.$on(NewSearchInputEvent, () => null); // no-op for now
    this.$refs.searchInput.$on(UserSearchEvent, this.searchForUser); // search for user
  },
  methods: {
    alert: msg => alert(msg),
    generateEditUserLink: function() {
      let url = `${RightTrim("/", this.userAdminUrl)}/`;
      return url;
    },
    viewProfile(user) {
      window.location.href = `${RightTrim("/", this.userProfileUrl)}/${
        user.id
      }`;
    },
    goToMessage(id) {
      window.location = `${RightTrim(
        "/",
        this.messageRootUrl
      )}/${encodeURIComponent(id)}`;
    },
    searchForUser: function(searchString) {
      if ("" === searchString.trim()) {
        window.location.href = this.rootUserAdminUrl;
        return;
      }
      window.location.href = `${RightTrim(
        "/",
        this.rootUserAdminUrl
      )}?${SearchParam}=${encodeURIComponent(searchString)}`;
    },
    manage: function(user) {
      window.location.href = `${RightTrim("/", this.userAdminUrl)}/${user.id}`;
    },
    add: function(e) {
      let that = this;
      this.api
        .addRole(e.id, e.email, e.role)
        .then(
          response => {
            that.users.find(x => x.email === e.email).roles =
              response.data.roles;
          },
          error => {
            alert(
              `Unable to add the role ${e.role}: ${error.response.data.error}`
            );
          }
        )
        .catch(() =>
          alert(`Unable to add the role ${e.role} due to unknown reasons.`)
        );
    },
    remove: function(e) {
      let that = this;
      this.api
        .removeRole(e.id, e.email, e.role)
        .then(
          response => {
            that.users.find(x => x.email === e.email).roles =
              response.data.roles;
          },
          error => {
            alert(
              `Unable to remove the role ${e.role}: ${error.response.data.error}`
            );
          }
        )
        .catch(() =>
          alert(`Unable to remove the role ${e.role} due to unknown reasons`)
        );
    },
    changeSearchRole: function(newRole) {
      if (newRole === this.initialSelectedRole) {
        return;
      }
      if (newRole === "All") {
        window.location.href = this.rootUserAdminUrl;
      } else {
        window.location.href = `${RightTrim(
          "/",
          this.rootUserAdminUrl
        )}/Roles/${newRole}`;
      }
    }
  },
  data: function() {
    return {
      api: new MentorApplicationApi(this.apiRootUrl)
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
